import type { ReactNode } from 'react'
import { Box } from '@mui/material'

export const SiderIcon = ({ selected, children }: { selected?: boolean; children: ReactNode }) => (
  <Box
    sx={{
      width: 56,
      height: 32,
      borderRadius: '24px',
      bgcolor: selected ? 'background.paper' : 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'background 0.2s',
    }}
  >
    {children}
  </Box>
)
